module.exports = __webpack_public_path__ + "static/media/Taylor.c5b0b80f.png";